export const VEHICLE_STATUS = {
	active: 'active',
	sold: 'sold',
	expired: 'expired',
	onHold: 'on_hold',
	republished: 'republished',
	pendingCheckout: 'pending_checkout',
	deleted: 'deleted',
	pending: 'pending',
	inactive: 'inactive',
	repost: 'repost',
};

export const INACTIVE_STATUS = [
	VEHICLE_STATUS.inactive,
	VEHICLE_STATUS.onHold,
	VEHICLE_STATUS.pending,
	VEHICLE_STATUS.expired,
];

const ENDED_AND_INACTIVE_STATUSES = [
	VEHICLE_STATUS.sold,
	VEHICLE_STATUS.expired,
	VEHICLE_STATUS.onHold,
	VEHICLE_STATUS.republished,
	VEHICLE_STATUS.pendingCheckout,
	VEHICLE_STATUS.deleted,
	VEHICLE_STATUS.inactive,
	VEHICLE_STATUS.repost,
];

export const isActiveStatus = (status) => !ENDED_AND_INACTIVE_STATUSES.includes(status);

export const SALE_TYPE = {
	auction: 'auction',
	marketplace: 'marketplace',
};
